import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const useGoogleTagManager = (gtmId: string) => {
  useEffect(() => {
    if (!gtmId) return;

    if (document.querySelector(`script[src*="${gtmId}"]`)) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [gtmId]);
};
